import SoftLimitCalendar, { SoftLimitProps } from './SoftLimitCalendar'
import { dateToYMDformat, toLongDate, YEAR } from 'utils/date'
import useTranslation from 'hooks/useTranslation'
import React, { useState } from 'react'
import Popup from './Popup'

interface DateRangePickerPopupProps {
  startDate: Date
  endDate?: Date
  minStartDate?: Date
  minEndDate?: Date
  maxStartDate?: Date
  maxEndDate?: Date
  selectedStart?: boolean
  rangeCom?: JSX.Element
  disabledEndDate?: boolean
  isStartDateDisabled?: boolean
  /** miekkie granice daty startu (klikniecie poza nimi pokazuje modal zamiast wyboru) */
  startLimits?: SoftLimitProps
  /** miekkie granice daty konca */
  endLimits?: SoftLimitProps
  onChange: (date: string, isStartSelected: boolean) => void
}

const DateRangePickerPopup: React.FC<DateRangePickerPopupProps> = ({ startDate, endDate, isStartDateDisabled, minStartDate, minEndDate, maxStartDate, maxEndDate, disabledEndDate, rangeCom, selectedStart: initialSelectedStart = true, startLimits, endLimits, onChange }) => {
  const [selectedStart, selectStart] = useState(initialSelectedStart)
  const { t, lang } = useTranslation('filters')

  const onTouchStart = (e: React.TouchEvent) => {
    const initialX = e.touches[0].clientX
    const initialY = e.touches[0].clientY

    const touchend = () => {
      window.removeEventListener('touchmove', touchmove)
      window.removeEventListener('touchend', touchend)
    }

    const touchmove = (e: TouchEvent) => {
      const currentX = e.touches[0].clientX
      const currentY = e.touches[0].clientY
      if (Math.abs(initialX - currentX) > 100) {
        touchend()
        handleClickArrow(currentX < initialX)
      } else if (Math.abs(initialY - currentY) > 20) {
        touchend()
      }
    }

    const handleClickArrow = (next: boolean) => {
      const element = document.querySelector(`.react-calendar__navigation__${next ? 'next' : 'prev'}-button`)
      if (element) (element as HTMLElement).click()
    }

    window.addEventListener('touchmove', touchmove)
    window.addEventListener('touchend', touchend)
  }

  if (typeof startDate !== 'object') return null
  return (
    <Popup>
      <div>
        <div className='popup__inputs'>
          <div
            className={`popup__input ${selectedStart ? '--selected' : ''}`}
            onClick={() => {
              if (isStartDateDisabled) return
              selectStart(true)
            }}>
            <span>{t('from')}<b>{toLongDate(startDate, lang, true)}</b></span>
          </div>
          <div
            className={`popup__input ${!selectedStart ? '--selected' : ''}`}
            onClick={() => {
              if (!disabledEndDate) {
                selectStart(false)
              }
            }}>
            <span>{t('to')}<b>{endDate ? toLongDate(endDate, lang, true) : '∞'}</b></span>
          </div>
        </div>

        <div onTouchStart={onTouchStart}>
          <SoftLimitCalendar
            softMinDate={(selectedStart ? startLimits : endLimits)?.softMinDate}
            softMaxDate={(selectedStart ? startLimits : endLimits)?.softMaxDate}
            getBlockedModal={(selectedStart ? startLimits : endLimits)?.getBlockedModal}
            locale={lang}
            minDetail='year'
            key={`${selectedStart}-${endDate?.toString()}`}
            value={(startDate && endDate) ? [startDate, endDate] : startDate || [new Date()]}
            minDate={selectedStart ? minStartDate : minEndDate}
            maxDate={(selectedStart && maxStartDate) ? maxStartDate : (maxEndDate || new Date(Date.now() + (5 * YEAR)))}
            returnValue={selectedStart ? 'start' : 'end'}
            showNeighboringMonth={false}
            onChange={(date) => {
              if (Array.isArray(date) || date === null) return
              if (selectedStart && !disabledEndDate) selectStart(false)
              onChange(dateToYMDformat(date), selectedStart)
            }}
          />
        </div>
        {rangeCom}
      </div>
    </Popup>
  )
}

export default DateRangePickerPopup